import * as Papa from "papaparse";
import Joi from "joi-browser";

// Old: every header was camelCased before upload, which silently rewrote customer
// column names in the campaign payload (state_name -> stateName). Column names must
// reach the backend exactly as uploaded — only the phone column needs to be located.
// function toCamelCase(str) {
//     return str
//       .trim()
//       .toLowerCase()
//       .replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""));
//   }
//
//   function normalizeRow(row) {
//     const normalized = {};
//     for (const [key, value] of Object.entries(row)) {
//       normalized[toCamelCase(key)] = value;
//     }
//     return normalized;
//   }

// Locates the phone column tolerantly ("Phone", "PHONE ", ...). An exact `phone`
// header wins if both an exact and a variant header exist.
function findPhoneHeader(headers) {
  const fields = headers || [];
  return (
    fields.find((h) => h === "phone") ??
    fields.find((h) => h.trim().toLowerCase() === "phone")
  );
}

// Keeps every column name exactly as uploaded; only the phone column is renamed to
// the literal `phone` key the backend contract requires. Rows without a phone value
// are dropped.
export function extractContacts(rows, headers) {
  const phoneHeader = findPhoneHeader(headers);
  if (!phoneHeader) return [];

  return rows
    .map((row) => {
      if (phoneHeader === "phone") return row;
      const { [phoneHeader]: phone, ...rest } = row;
      return { phone, ...rest };
    })
    .filter((row) => row.phone?.trim());
}

export const csvFieldTemplate = {
  name: "csvFile",
  label: "CSV File *",
  type: "csv",
  placeholder: "Click to select a CSV file",
  info: (
    <p className="text-sm text-gray-500">
      CSV must include a{" "}
      <code className="text-xs bg-zinc-100 dark:bg-zinc-800 px-1 py-0.5 rounded">
        phone
      </code>{" "}
      column
    </p>
  ),
  onFileChange: (file, onChange, name, setFileMeta) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      // Trims stray whitespace (and Excel's BOM) from headers without otherwise
      // altering the uploaded column names.
      transformHeader: (header) => header.trim(),
      complete(results) {
        // Old: const rows = results.data.map(normalizeRow);
        //      const valid = rows.filter((row) => row.phone?.trim());
        // Replaced because normalizeRow camelCased every column name; original
        // names must be preserved in the payload (see extractContacts above).
        const valid = extractContacts(results.data, results.meta.fields);
        setFileMeta({
          fileName: file.name,
          total: valid.length,
          skipped: results.data.length - valid.length,
          // Which column identifies a contact — the csv renderer's skip/error
          // messages name it, so it must match what this filter keyed on.
          column: "phone",
        });
        onChange({
          currentTarget: {
            name,
            value: valid.length > 0 ? JSON.stringify(valid) : "",
          },
        });
      },
    });
  },
};

export const csvFieldSchema = {
  csvFile: Joi.string().required().label("CSV File"),
};
